import { defineComponent } from "vue";
import AISubtitlesOverlay from "../common/widgets/AITools/AISubtitles.vue.mjs";
import { useRoomOverlayHooks } from "./useRoomOverlayHooks.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "RoomOverlay",
  setup(__props) {
    const { getOverlayMap } = useRoomOverlayHooks();
    const overlayMap = getOverlayMap();
    return { __sfc: true, getOverlayMap, overlayMap, AISubtitlesOverlay };
  }
});
export {
  _sfc_main as default
};
